import type { ClaimResponse } from './claim-response';

export const claimResponseProcessedPartiallyPaid: ClaimResponse = {
  MedicalAidMessage: {
    '@Version': '6.0.0',
    Claim: {
      Transaction: {
        ReferenceNum: '220812180944152uvnesro',
        DataSet: '01',
        InvoiceNum: 'QM00313642208-00002',
      },
      Details: {
        ClaimFinancials: {
          TotalClaimedAmt: '50712',
          TotalPaidProvAmt: '42570',
          BalanceOutstanding: '8142',
        },
        LineItems: [
          {
            UniqueID: '3',
            StatusCode: '7',
            StatusDesc: 'Processed',
            MALineRefNum: '8465880422',
            Editable: 'No',
            Reversible: 'Yes',
            PayWho: 'Provider',
            LineItemFinancials: {
              BilledAmt: '6187',
              MAPayable: '0',
              MedicalAidRate: '6187',
            },
            Responses: [
              {
                '@Type': 'Reason',
                Code: '514',
                Desc: 'Benefits limit reached/depleted/exhausted. (514)',
              },
            ],
          },
          {
            UniqueID: '1',
            StatusCode: '7',
            StatusDesc: 'Processed',
            MALineRefNum: '8465880422',
            Editable: 'No',
            Reversible: 'Yes',
            PayWho: 'Provider',
            LineItemFinancials: {
              BilledAmt: '42570',
              MAPayable: '42570',
              MedicalAidRate: '42570',
            },
            Responses: [
              {
                '@Type': 'Reason',
                Code: '247',
                Desc: 'Enhanced Fee Included in Bulk Payment Above. (247)',
              },
            ],
          },
          {
            UniqueID: '2',
            StatusCode: '7',
            StatusDesc: 'Processed',
            MALineRefNum: '8465880422',
            Editable: 'No',
            Reversible: 'Yes',
            PayWho: 'Provider',
            LineItemFinancials: {
              BilledAmt: '1955',
              MAPayable: '0',
              MedicalAidRate: '1955',
            },
            Responses: [
              {
                '@Type': 'Reason',
                Code: '514',
                Desc: 'Benefits limit reached/depleted/exhausted. (514)',
              },
            ],
          },
        ],
      },
      Disclaimer:
        "Medscheme-Nexus has confirmed receipt of your claim. All line items in this claim have been fully processed, including processing against the member's benefits. Payment is not guaranteed as a result of this submission.",
    },
  },
};
